import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import type { DefaultTheme } from 'styled-components';
import styled from 'styled-components';

export const MerchantWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing[16],
  width: '100%',
  gap: theme.spacing[16],

  [`${theme.mediaBreakpointUp.lg}`]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export const MerchantLeftSide = styled.div({
  display: 'flex',
  flexDirection: 'row',
});

export const MerchantLogo = styled.img(({ theme }) => ({
  width: 40,
  height: 40,
  marginRight: theme.spacing[16],
  padding: theme.spacing[8],
  borderRadius: 2,
  overflow: 'hidden',
  border: `1px solid ${theme.colors.surface05}`,
  flexShrink: 0,
}));

export const MerchantName = styled(Typography).attrs({
  variant: TextStyles['Heading 5'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  marginBottom: theme.spacing[8],
}));

export const MerchantInfoItemName = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
}));

export const MerchantInfoIconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  height: 22,
});

export const SocialMediaImg = styled.img<{ size: 'small' | 'large' }>(({ theme, size }) => ({
  width: size === 'small' ? 16 : 24,
  height: size === 'small' ? 16 : 24,
  flexShrink: 0,

  [`${theme.mediaBreakpointUp.lg}`]: {
    width: 16,
    height: 16,
  },
}));

export const SocialMediaName = styled(MerchantInfoItemName)<{ show?: boolean }>(({ theme, show }) => ({
  display: show ? 'flex' : 'none',

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: 'flex',
  },
}));

export const MerchantInfoItem = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',

  svg: {
    width: 16,
    height: 16,
    minWidth: 16,
  },

  'svg, img': {
    marginRight: theme.spacing[8],
  },

  a: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    ':not(:first-child)': {
      marginTop: theme.spacing[4],
    },
  },
}));

export const MerchantSocialMedia = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: theme.spacing[8],

  [`${theme.mediaBreakpointDown.md}`]: {
    [`${MerchantInfoItem}:last-child > img`]: {
      marginRight: 0,
    },
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing[4],
  },
}));

export const MerchantInfo = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const IframeStyle = (theme: DefaultTheme) => ({
  border: `0.5px solid ${theme.colors.surface05}`,
  borderRadius: 4,
  margin: '0 auto !important',
  flexShrink: 0,

  [`${theme.mediaBreakpointUp.lg}`]: {
    margin: '0 !important',
  },
});

export const SocialIframe = styled.iframe(({ theme }) => ({
  ...IframeStyle(theme),
}));

export const TiktokBlockQuote = styled.blockquote(({ theme }) => ({
  iframe: {
    ...IframeStyle(theme),
  },
}));
